import { render, staticRenderFns } from "./LayersModule.vue?vue&type=template&id=8eb64b52&scoped=true"
import script from "./LayersModule.vue?vue&type=script&lang=js"
export * from "./LayersModule.vue?vue&type=script&lang=js"
import style0 from "./LayersModule.vue?vue&type=style&index=0&id=8eb64b52&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb64b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eb64b52')) {
      api.createRecord('8eb64b52', component.options)
    } else {
      api.reload('8eb64b52', component.options)
    }
    module.hot.accept("./LayersModule.vue?vue&type=template&id=8eb64b52&scoped=true", function () {
      api.rerender('8eb64b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/LayersModule.vue"
export default component.exports